import { t } from "i18next";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import RoleRequire from "../../helpers/auth/RoleRequire";
import { useAppStore } from "../../stores/RootStore";
import { useScreenStore } from "../../stores/ScreenStore";
import { ScreenType } from "../../types/types";
import { Button } from "../../ui/Button";
import { Input } from "../../ui/Input/Input";
import { ScrollArea } from "../../ui/ScrollArea/ScrollArea";

export default function MonitoringGrid({onClose}:{onClose: () => void}) {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const screens = useAppStore().screens;

  const handleSearch = (event: any) => {
    setSearch(event.target.value);
  };

  // Фильтрация через поиск
  let data = screens?.filter(
    (item) =>
      item.attributes.name.toLowerCase().includes(search.toLowerCase())
  );

  function selectScreen(screen: ScreenType) {
    navigate(`/monitoring/${screen.id}`)
    onClose()
  }

  function addScreen() {
    navigate("/monitoring/new")
    onClose()
  }

  return (
    <>
      <div className="flex flex-col w-full">
        <div className="flex flex-row w-full h-14 items-center gap-4 px-6 justify-between">
          <Input 
            className="h-8"
            placeholder={t("equipment_search")}
            onChange={handleSearch}
            value={search}
            autoComplete="off"
            width="100%" 
          />
          
          <RoleRequire role="maintainer">
            <Button variant={"default"} size={"md"} onClick={() => addScreen()}>{t("add")}</Button>
          </RoleRequire>
        </div>
      </div>

      {!data?.length ? ( // Заглушка для отсутствия данных при поиске
      <div className="flex w-full h-full justify-center items-center">
          {t("no_data")}
      </div>
      ) : (
      <>
        <div className="flex items-center font-medium text-muted-foreground px-6 text-sm h-10 w-full">
          <div className="w-full">{t('name')}</div>
          <div className="w-[150px]">{t('equipment')}</div>
          <div className="w-[150px]">{t('division')}</div>
        </div>
        <ScrollArea type="hover" className="h-full">
          {data?.map((screen, i) => (
          <div key={i} className={`flex w-full h-10 items-center px-6 cursor-pointer hover:bg-muted hover:text-foreground text-sm`} onClick={() => selectScreen(screen)}>
              <div className="font-medium w-full truncate">{screen?.attributes?.name}</div>
              <div className="font-medium w-[150px] text-left truncate">{screen?.attributes?.equipment_item_relations?.length}</div>
              <div className="font-medium w-[150px] text-left truncate">{screen?.attributes?.division?.name}</div>
          </div>
          ))}
        </ScrollArea>
      </>
      )}
    </>
  )
} 